import {Nullable} from './Support/Nullable';
import {Duration} from '../Domain/Duration';
import {Distance} from '../Domain/Distance';
import {Power} from '../Domain/Power';
import {Fraction} from '../Domain/Fraction';
import {Force} from '../Domain/Force';
import {Energy} from '../Domain/Energy';
import {StrokeRate} from '../Domain/StrokeRate';
import {PartialWorkout} from './PartialWorkout';
import {WorkoutExecutionType} from './WorkoutExecutionType';

export interface FullWorkoutPartResult {
    stroke_count: number;
    elapsed_time: Duration;
    traveled_distance: Distance;
    burned_calories: Energy | null;
    average_power: Power | null;
    average_relative_peak_force_position: Fraction | null;
    average_split: Duration | null;
    average_peak_force: Force | null;
    average_stroke_length: Distance;
    average_energy_per_stroke: Energy | null;
    average_stroke_rate: StrokeRate | null;
    average_drive_time: Duration | null;
    average_recover_time: Duration | null;
    total_energy: Energy | null;
}

export interface FullWorkout extends PartialWorkout {
    id: number;
    original_user_id: number | null;
    executed_at: Date;
    share_url: string;
    track_geo_url: string | null;
    track_geo_strokes_url: string | null;
    track_heart_rate_url: string | null;
    is_claimed: boolean;
    workout_part_results: FullWorkoutPartResult[];
    training_plan: Nullable<{
        title: string;
        workouts: Array<{
            id: number;
            executed_at: Date;
        }>;
        intervals: Array<{
            repetitions: number;
            parts: Array<{
                type: PartType;
            }>;
        }>;
    }>;
}

export interface IndoorFullWorkout extends FullWorkout {
    execution_type: WorkoutExecutionType.INDOOR;
    track_geo_url: null;
}

export interface OutdoorFullWorkout extends FullWorkout {
    execution_type: WorkoutExecutionType.OUTDOOR;
    track_geo_url: string;
    track_heart_rate_url: string | null;
}

export enum PartType {
    Duration = 'DURATION',
    Distance = 'DISTANCE',
    Strokes = 'STROKES',
    Rest = 'REST',
}
